import { render, staticRenderFns } from "./perinformation.vue?vue&type=template&id=f3750332&scoped=true&"
import script from "./perinformation.vue?vue&type=script&lang=js&"
export * from "./perinformation.vue?vue&type=script&lang=js&"
import style0 from "./perinformation.vue?vue&type=style&index=0&id=f3750332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3750332",
  null
  
)

export default component.exports